import React, { useState, useEffect, useContext } from "react";
import axiosInstance from "../../axiosInstance";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { Visibility as VisibilityIcon } from "@mui/icons-material";
import Table from "./../Theme/Table.js";
import Spinner from "../Spinner";
import ActionButtons from "../ActionButton.js";
import { RoleContext } from "../RoleContext";

const CompanyActiveTripsList = () => {
  const roleData = useContext(RoleContext);
  const role = JSON.parse(roleData);
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getTrips = async () => {
    try {
      const response = await axiosInstance.get("companyActiveTrips/");
      setTrips(Array.isArray(response.data) ? response.data : []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong ...");
    }
  };

  useEffect(() => {
    getTrips();
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Passenger Information",
        columns: [
          { Header: "ID", accessor: "id" },
          { Header: "First Name", accessor: "passenger.firstName" },
          { Header: "Last Name", accessor: "passenger.lastName" },
          { Header: "Phone Number", accessor: "passenger.phoneNumber" },
        ],
      },
      {
        Header: "Driver Information",
        columns: [
          { Header: "First Name", accessor: "driver2.firstName" },
          { Header: "Last Name", accessor: "driver2.lastName" },
          { Header: "Phone Number", accessor: "driver2.phoneNumber" },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,
            Cell: (row) => {
              const status = row.cell.row.original.status || "Active";
              return (
                <Chip
                  label={status}
                  color={status === "Active" ? "success" : "warning"}
                  variant="filled"
                  sx={{
                    fontWeight: "bold",
                    borderRadius: "8px",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                />
              );
            },
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {role.filter((e) => e.perm_name === "list_active_trips").length > 0 && (
                  <Tooltip title="View active trip">
                    <span>
                      <VisibilityIcon
                        color="success"
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate(`/tripDetail/${row.cell.row.original.id}`)}
                      />
                    </span>
                  </Tooltip>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="content-wrappers" style={{ marginTop: "-40px" }}>
      <div className="content-wrappers">
        <br />
        <br />
        <ToastContainer />

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <ActionButtons title="Company Active Trips" is_all_trips={false} />
                  <div className="card-body">
                    {loading ? (
                      <div>
                        <Spinner />
                      </div>
                    ) : (
                      <Table columns={columns} data={trips} edit="trip" detail="viewTrip" />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CompanyActiveTripsList;
